/**
 * Navigation Configuration
 * Defines the main menu items, their paths, and icons used throughout the application.
 */
import { paths } from '../router/paths';
import {
  IconLayoutDashboard,
  IconPlanet,
  IconArrowsExchange,
  IconUsers,
  IconError404,
  IconExclamationCircle,
  IconServerOff,
  IconBook,
  IconAccessPointOff,
} from '@tabler/icons-react';
import type { TranslationKey } from '../locales/types';
import type { Icon } from '@tabler/icons-react';

interface NavItem {
  title: TranslationKey;
  path: string;
  icon: Icon;
}

export const NAV_DATA: readonly NavItem[] = [
  { title: 'nav.dashboard', path: paths.dashboard, icon: IconLayoutDashboard },
  { title: 'nav.planets', path: paths.planet.list, icon: IconPlanet },
  { title: 'nav.users', path: paths.users.list, icon: IconUsers },
  { title: 'nav.transactions', path: paths.transaction.list, icon: IconArrowsExchange },
  { title: 'nav.403', path: paths.page403, icon: IconExclamationCircle },
  { title: 'nav.404', path: paths.page404, icon: IconError404 },
  { title: 'nav.500', path: paths.page500, icon: IconServerOff },
  { title: 'nav.offline', path: paths.offline, icon: IconAccessPointOff },
  { title: 'nav.docs', path: paths.docs, icon: IconBook },
] as const;
